export default __webpack_public_path__ + "static/media/suicide.b72f1f9f.png";